var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFi = function SvgFi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.386 20.354h15.584V32H-5.386V20.354z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.19 0h9.37v32h-9.37V0z",
    fill: "#0062DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.386 11.636h56.104v8.727H-5.386v-8.727z",
    fill: "#0062DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.386 0h15.584v11.646H-5.386V0zM19.55 20.354h31.17V32H19.55V20.354zM19.55 0h31.17v11.646H19.55V0z",
    fill: "#FFF"
  })));
};
export default SvgFi;